import React from "react";
import { ROUTES } from "app/router/data";
import { useIntercom } from "app/hooks/useIntercom";
import { PageLoader } from "app/components/page-loader";
import { useInitialLoad } from "app/hooks/useInitialLoad";
import {
  RouteObject,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import { useCMSData } from "app/hooks/useCMSData";

export default function Router() {
  useIntercom();
  useInitialLoad();
  useCMSData({ loadData: true });

  const setUpRouter = () => {
    const result: RouteObject[] = ROUTES;
    return createBrowserRouter(result);
  };

  const [router] = React.useState(setUpRouter);

  return <RouterProvider fallbackElement={<PageLoader />} router={router} />;
}
